/**
* Date  : 2023/11/17
* Author : zhuql
* Declare : index
*/

import React from 'react';
import classNames from 'classnames';

import './index.scss';

export default function ServiceWarp(props) {
  const { isMove } = props;
  return (
    <div className="ServiceWarp" id="ServiceWarp-ssjskcjs">
      <div className="left-warp">
        <div className="left-warp-title"><span>一站式</span>配音服务</div>
        {
          tabs.map((item, index) => {
            return (
              <div className="item" key={index}>
                <div className="item-text">{item.value}</div>
              </div>
            );
          })
        }
      </div>
      <img className={classNames('right-warp', { 'active': isMove })} src={BG_IMG} />
    </div>
  );
}

const BG_IMG = 'https://oss.5rs.me/oss/uploadfe/png/323cfc4726439f5003b0b928e63bfc67.png';

const tabs = [
  {
    value: '一站式的语音合成服务，将整个制作流程交给专业团队处理。高效、省时、经济。'
  },
  {
    value: '我们有汇集了各种类型、风格和题材的优质创作者团队。根据项目的规模和时间要求灵活调整，满足您的商业需求。'
  }
];